module.exports = __webpack_public_path__ + "static/scale-model-of-annex-galleries-in-santa-rosa-california-ab9d607d0ce3c4d9637c5c56a180ba3e.png";